import { Navigate, Outlet } from 'react-router'
import { useAuthStore } from '@/features/auth/store/store.ts'
import { routes } from '@/routes'

function LuxeSubmissionsRoute() {
	const accessToken = useAuthStore((state) => state.accessToken)

	if (!accessToken) {
		return (
			<Navigate
				replace
				to={routes.LUXE_SUBMISSIONS_LOGIN.handle.fullPath}
			/>
		)
	}

	return <Outlet />
}

export { LuxeSubmissionsRoute }
